import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { MinMaxDiscountFormInputComponent } from './components/min-max-discount-form-input.component';
import { PromoLinkFormInputComponent } from './components/promotion-code-link-display-form.component';

export default [
    registerFormInputComponent('min-max-discount-form-input', MinMaxDiscountFormInputComponent),
    registerFormInputComponent('promo-link-display-form', PromoLinkFormInputComponent),
];
